var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-naf animation--wave-naf shape--rect shape--flat",style:({ width: _vm.width, height: _vm.height, borderRadius: _vm.borderRadius })})
}
var staticRenderFns = []

export { render, staticRenderFns }